export default __webpack_public_path__ + "static/media/stop-canceled.853618e6.svg";